import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import i18n from './i18n/i18n';

export function InvalidateQueriesOnLanguageChange() {
	const queryClient = useQueryClient();

	useEffect(() => {
		const handleLanguageChanged = () => {
			void queryClient.invalidateQueries();
		};
		i18n.on('languageChanged', handleLanguageChanged);
		return () => {
			i18n.off('languageChanged', handleLanguageChanged);
		};
	}, [queryClient]);

	return null;
}
